<script>
	import { onMount, onDestroy } from "svelte";
	import { getPosts } from "../getPosts.js";
	import { store } from "../store.js";
	import Select from "svelte-select";
	import { getTerms } from "../getTerms.js";
	import Mode from "./Mode.svelte";

	// Le filtre par lieu

	let type_production_terms = [],
		type_production_value;

	// New variables for departement filter
	let departement_terms = [],
		departement_value;

	let currentFilters = {
		type_production: null,
		departement: null
	};

	function updateFilters() {
		$store.options[$$props.id].loading = true;

		let taxQueries = [];
		if (currentFilters.type_production) {
			taxQueries.push({
				taxonomy: "type_production",
				field: "slug",
				terms: currentFilters.type_production
			});
		}
		if (currentFilters.departement) {
			taxQueries.push({
				taxonomy: "departement",
				field: "slug",
				terms: currentFilters.departement
			});
		}

		if (taxQueries.length > 0) {
			$store.options[$$props.id].filtres.taxonomies = encodeURIComponent(
				JSON.stringify(taxQueries)
			);
		} else {
			delete $store.options[$$props.id].filtres.taxonomies;
		}

		let params = new URLSearchParams(
			$store.options[$$props.id].filtres
		).toString();

		getPosts(params).then(myPosts => {
			$store.posts[$$props.id] = myPosts;
			$store.options[$$props.id].found_posts = myPosts.found_posts;
			$store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
			$store.options[$$props.id].loading = false;
		});
	}

	onMount(async () => {
		// Les publics
		let type_productionJSON = await getTerms("type_production");

		let filteredTypeProduction = type_productionJSON.map(term => {
			return {
				value: term.slug,
				label: term.name
			};
		});
		type_production_terms = filteredTypeProduction;

		// Fetch departement terms
		let departementJSON = await getTerms("departement");
		let filteredDepartement = departementJSON.map(term => ({
			value: term.slug,
			label: term.name
		}));
		departement_terms = filteredDepartement;

		$store.options[$$props.id].loading = false;
	});

	async function filter_by_type_production(event) {
		currentFilters.type_production = event.detail.value;
		updateFilters();
	}

	async function unfilter_type_production(event) {
		currentFilters.type_production = null;
		updateFilters();
	}

	async function filter_by_departement(event) {
		currentFilters.departement = event.detail.value;
		updateFilters();
	}

	async function unfilter_departement(event) {
		currentFilters.departement = null;
		updateFilters();
	}
</script>

<div class="cs_secondary_filters">
	<div class="filter_select filter_by_location" style="min-width: 240px;">
		<Select
			title="Type de production"
			items={type_production_terms}
			value={type_production_value}
			showChevron={true}
			placeholder={"Type de production"}
			placeholderAlwaysShow={true}
			on:select={filter_by_type_production}
			on:clear={unfilter_type_production}
		/>
	</div>
	<div class="filter_select filter_by_location" style="min-width: 240px;">
		<Select
			title="Département"
			items={departement_terms}
			value={departement_value}
			showChevron={true}
			placeholder={"Département"}
			placeholderAlwaysShow={true}
			on:select={filter_by_departement}
			on:clear={unfilter_departement}
		/>
	</div>
</div>
